<template>
    <v-app>
        <v-dialog v-model="dialog" max-width="800">
            <v-card>
                <v-card-title>
                    {{`${edit?'Update':'Add'}`}} Lesson
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Title" v-model="lesson.title" outlined dense>

                            </v-text-field>
                            <span class="text-danger" v-if="$v.lesson.title.$error">Title is required</span>

                        </v-col>
                        <div class="col-12">
                            <ckeditor v-model="lesson.description"></ckeditor>
                            <span class="text-danger"
                                  v-if="$v.lesson.description.$error">Description is required</span>
                        </div>


                        <v-col cols="6">
                            <v-select
                                    :items="syllabuses"
                                    v-model="lesson.syllabus_id"
                                    outlined
                                    dense
                                    label="Syllabus"
                                    item-text="title"
                                    item-value="id"
                            >

                            </v-select>

                        </v-col>
                        <v-col cols="6">
                            <v-select
                                    :items="topics"
                                    v-model="lesson.topic_id"
                                    outlined
                                    dense
                                    label="Topic"
                                    item-text="title"
                                    item-value="id"
                            >

                            </v-select>

                        </v-col>
                        <div class="col-3">
                            <v-switch
                                    v-model="lesson.is_active"
                                    label="Status"
                            >
                            </v-switch>
                        </div>
                        <v-col cols="12">
                            <div class="text-right float-right">
                                <v-btn depressed @click="resetForm" class="text-gray btn btn-standard  ">
                                    Cancel
                                </v-btn>
                                <v-btn depressed :loading="isBusy" @click="createOrUpdate"
                                       class="text-white ml-2 btn btn-primary ">
                                    Save
                                </v-btn>
                            </div>

                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>

</template>
<script>
    import {required} from "vuelidate/lib/validators";
    import LessonsService from "@/core/services/lesson-planner/lessons/LessonsService";
    import {LessonPlannerMixin} from "@/mixins/LessonPlannerMixin";

    const lessonService = new LessonsService();

    export default {
        name: 'lessons',
        mixins: [LessonPlannerMixin],
        validations: {
            lesson: {
                title: {required},
                description: {required},

            }
        },
        computed: {
            topic_id() {
                return this.$route.params.topic_id;
            }, syllabus_id() {
                return this.$route.params.syllabus_id;
            }
        },
        data() {
            return {
                dialog: false,
                edit: false,
                sizeExceed: false,
                isBusy: false,
                search: {
                    active: "active",
                    is_parent: 1,
                },
                lesson: {
                    title: null,
                    lesson_number: null,
                    topic_id: null,
                    syllabus_id: null,
                    is_active: true
                },
            };
        },
        mounted() {
            this.getSyllabus();
            this.getTopics(this.syllabus_id);
        },
        methods: {
            showModal(id = null) {
                if (id) {
                    this.edit = true
                    this.__get(id)
                }
                this.dialog = true;
                // this.$refs["my-modal"].show();
            },
            hideModal() {
                this.dialog = false;
            },
            toggleModal() {
                this.$refs["my-modal"].toggle("#toggle-btn");
            },
            __get(id) {
                lessonService.show(this.topic_id, id).then(response => {
                    this.lesson = response.data.lesson
                })
            },

            createOrUpdate() {
                this.$v.lesson.$touch();
                if (this.$v.lesson.$error) {
                    setTimeout(() => {
                        this.$v.lesson.$reset();
                    }, 3000);
                } else {
                    let fd = this.lesson;
                    if (this.edit) {
                        this.__update(fd);
                    } else {
                        this.__create(fd);
                    }
                }
            },
            __update(fd) {
                this.isBusy = true;
                lessonService
                    .update(this.topic_id, this.lesson.id, fd)
                    .then(response => {
                        this.isBusy = false;
                        this.$snotify.success("Information updated");

                        this.resetForm();
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        // console.log(error);
                    });
            },

            checkSize(file) {
                let size = file.size / 1024 / 1024;
                let mbSize = size.toFixed(2);
                if (mbSize > 20) {
                    this.sizeExceed = true;
                } else {
                    this.sizeExceed = false;
                }
            },
            __create(fd) {
                this.isBusy = true;
                lessonService
                    .store(this.topic_id, fd)
                    .then((response) => {
                        this.isBusy = false;
                        this.resetForm();
                        this.$snotify.success("Information added");

                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$snotify.error("Something Went Wrong");
                        console.log(error);
                    });
            },
            resetForm() {
                this.$v.lesson.$reset();
                this.edit = false;
                this.lesson = {
                    title: null,
                    is_active: true
                };
                this.hideModal();
                this.$emit("refresh_lesson");
            }
        }
    };
</script>
